import ArrowBackwardSquareFill from './ArrowBackwardSquareFill';

export default ArrowBackwardSquareFill;
